import { render, staticRenderFns } from "./detalhesFaturas.vue?vue&type=template&id=97c2fe4a&scoped=true&"
import script from "./detalhesFaturas.vue?vue&type=script&lang=js&"
export * from "./detalhesFaturas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c2fe4a",
  null
  
)

export default component.exports